module.exports = __webpack_public_path__ + "static/media/sbirka-video-banner.d081ecf0.jpg";